import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const Container = styled.div`
  width: 100%;
`

export const CreateButton = styled.div`
  display: flex;
  align-items: center;
`

export const CreateTitle = styled.div`
  ${typography.down1.semiBoldSans};
  color: ${colors.interactive.primaryEnabled};
`
